import React from 'react'

const Benefits = () => {
  return <h2>Benefits</h2>
}

export default Benefits
